import { IApplicationState } from '../../types/redux';

export function selectPuids(state: IApplicationState) {
  return state.adfox.puids;
}
